import type { ApplicationLogger } from "@shared/types/application-logger.types";
import { FrontendApplicationLogger } from "./application-logger.impl";

export const applicationLogger: ApplicationLogger =
  FrontendApplicationLogger.getInstance();
